import { __awaiter, __generator } from 'tslib';
import { DbVersion } from './db-utils.js';

function openGamesCorexDB() {
    return __awaiter(this, void 0, void 0, function () {
        function destroyDb() {
            return new Promise(function (res, rej) {
                var r = indexedDB.deleteDatabase(dbName);
                r.onsuccess = function () { return res(); };
                r.onerror = function () { return rej(r.error); };
            });
        }
        function createDb(db) {
            if (db.objectStoreNames.contains(gameStoreName)) {
                db.deleteObjectStore(gameStoreName);
            }
            var gamesStore = db.createObjectStore(gameStoreName, {
                autoIncrement: true,
            });
            gamesStore.createIndex('gameIdIndex', 'gameExternalId', {
                unique: false,
            });
        }
        var dbName, gameStoreName, isFirstOpen, db, gamesTable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dbName = 'games-db-corex';
                    gameStoreName = 'games-array';
                    isFirstOpen = !sessionStorage.getItem('games-db-corex-initialised');
                    if (!isFirstOpen) return [3 /*break*/, 2];
                    sessionStorage.setItem('games-db-corex-initialised', 'true');
                    return [4 /*yield*/, destroyDb()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, new Promise(function (resolve, reject) {
                        var req = indexedDB.open(dbName, DbVersion);
                        req.onupgradeneeded = function (e) {
                            var db = e.target.result;
                            createDb(db);
                        };
                        req.onsuccess = function () { return resolve(req.result); };
                        req.onerror = function () { return reject(req.error); };
                    })];
                case 3:
                    db = _a.sent();
                    gamesTable = function (mode) {
                        if (mode === void 0) { mode = 'readonly'; }
                        return db.transaction(gameStoreName, mode).objectStore(gameStoreName);
                    };
                    return [2 /*return*/, {
                            put: function (games) {
                                return new Promise(function (resolve, reject) {
                                    var chunkSize = 100;
                                    var dataArray = Array.from(games.values());
                                    var index = 0;
                                    function processNextChunk() {
                                        var gamesT = db.transaction(gameStoreName, 'readwrite');
                                        var gameStore = gamesT.objectStore(gameStoreName);
                                        for (var i = 0; i < chunkSize && index < dataArray.length; i++, index++) {
                                            gameStore.put(dataArray[index]);
                                        }
                                        gamesT.oncomplete = function () {
                                            if (index < dataArray.length) {
                                                setTimeout(processNextChunk);
                                            }
                                            else {
                                                resolve();
                                            }
                                        };
                                        gamesT.onerror = function () { return reject(gamesT.error); };
                                    }
                                    processNextChunk();
                                });
                            },
                            getById: function (gameId) {
                                return new Promise(function (res, rej) {
                                    var r = gamesTable().index('gameIdIndex').get(gameId);
                                    r.onsuccess = function () { return res(r.result); };
                                    r.onerror = function () { return rej(r.error); };
                                });
                            },
                            close: function () {
                                db.close();
                            },
                        }];
            }
        });
    });
}

export { openGamesCorexDB };
